// Import Material UI
import { Button, CircularProgress, Dialog, DialogContent, DialogTitle, Tooltip } from "@material-ui/core"
import { Close } from "@material-ui/icons"

// Import Packages
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

// Import Pages
import LogsDetail from "./LogsDetail";
import LogSummary from "./LogSummary";
import MidLogsDetail from "./MidLogsDetail";
import LogService from "../../../../services/LogService/LogService";
import LogInfoDetails from "./LogInfoDetails";
import OldLogsDetail from "./OldLogsDetail";
import { AllOperationLogs } from "./AllOperationLogs";
import FullScreen from "../../../../components/FullScreen/FullScreen";

// Import Helper
import { convertToDateFormat, showPreviewData } from "../../../../helpers/helper";

// Import Services
import QueueService from "../../../../services/QueueService/QueueService";

// Import Icons
import emptyPageIcon from '../../../../assets/icons/configurationIcons/empty-page.svg';
import actionInfoIcon from '../../../../assets/icons/configurationIcons/monitoring-action-info-icon.svg';
import actionErrorIcon from '../../../../assets/icons/configurationIcons/monitoring-action-error-icon.svg';

// Import Recoil
import { useRecoilValue } from "recoil";
import { baseOrigin, personalizationState } from "../../../../recoil-store/recoil-state";

// Import CSS
import "./OperationLogs.css";

const defaultLibraryImg = `default_library.png`

export const OperationLogs = ({ data, setOpenActivityLog, setSelectedOperation, status, handleShowAllOperationLogs }) => {
    const { t } = useTranslation();
    const [logs, setLogs] = useState([])
    const [isMidLogs, setIsMidLogs] = useState(false)
    const [isNewLogs, setIsNewLogs] = useState(false)
    const [operationCount, setOperationCount] = useState(0)
    const [logsCount, setLogsCount] = useState(0);
    const [triggerType, setTriggerType] = useState();
    const [loading, setLoading] = useState(false)
    const [type, setType] = useState("input");
    const [fullScreenValue, setFullScreenValue] = useState({ type: "", value: "" });
    const [selectedLog, setSelectedLog] = useState({});
    const [openEhLogs, setOpenEhLogs] = useState(false);
    const base_origin = useRecoilValue(baseOrigin);
    const personalization = useRecoilValue(personalizationState);
    const label = "MESSAGES.MONITORING."

    const handleClose = () => {
        setSelectedOperation({})
        setOpenActivityLog(false)
    }

    useEffect(() => {
        fetchData()
    }, [data]);

    useEffect(() => {
        setType("input")
    }, [selectedLog]);

    // useEffect(() => {
    //     const fetchFinalLogs = async () => {
    //         const res = await LogService.checkLogsBefore(`?operation_id=${data.operation_id}`, 30)
    //         if (res.status) {
    //             if (!res.count) {
    //                 setLoading(false)
    //             }
    //         }
    //     }
    //     if (isNewLogs) {
    //         setLoading(true)
    //         fetchFinalLogs()
    //     }
    // }, [isNewLogs]);

    const fetchData = (page, itemsPerPage) => {
        // Şu anki tarih ve saat
        var startDate = new Date();
        // 24 saat önceki tarih ve saat
        var endDate = new Date();
        endDate.setDate(endDate.getDate() - 1); // Dünden başla
        endDate.setHours(startDate.getHours()); // Saati aynı yap

        setLoading(true);
        QueueService.getQueueActivityLog(`?operation_id=${data.operation_id}`, endDate, startDate, 0, 5, "", "detail", true)
            .then((response) => {
                if (Array.isArray(response?.data)) {
                    // setIsMidLogs(response.hasGroupId)
                    // setIsNewLogs(response.new_design)
                    setLogs(response.data);
                    setOperationCount(response.operation_count)
                    setLogsCount(response.logs_count);
                }
                // else if (response.trigger_type) {
                //     setTriggerType(response.trigger_type);
                // } 
                else {
                    setLogs([]);
                }
                setIsMidLogs(response.hasGroupId)
                setIsNewLogs(response.new_design)
                setLoading(false);
            })
            .catch(() => {
                setLoading(false)
                //err
            });
    }

    const highlightText = (text, term) => {
        if (!term) return text;
        const regex = new RegExp(`(${term})`, 'gi');
        let parts = text.split(regex);
        parts = parts.map((part, index) => {
            if (regex.test(part)) {
                return <span key={index} className="logs-serach-finded-texts" style={{ color: "#46474E", backgroundColor: 'yellow' }}>{part}</span>
            }
            else {
                return part
            }
        });
        return parts
    };

    const findLogIcon = (tag) => {
        switch (tag) {
            case "INFO":
                return actionInfoIcon
            case "ERROR":
                return actionErrorIcon
            default:
                return actionInfoIcon
        }
    };

    const handleOpenInfoArea = (item) => {
        setSelectedLog(item);
    };

    return (
        <Dialog
            id="operation-log-dialog"
            data-test="autom-add-new"
            className="autom-group"
            open={true}
            onClose={handleClose}
            PaperProps={{
                style: {
                    minWidth: 696.89,
                    minHeight: 411.57,
                    maxWidth: "none",
                    // width: "706.49px",
                    // height: "411.57px",
                    width: selectedLog.level ? "68.5%" : "fit-content",
                    height: selectedLog.level ? "90%" : "411.57px",
                    borderRadius: " 4px",
                    backgroundColor: "transparent",
                    boxShadow: selectedLog.level ? "none" : "0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)",
                    flexDirection: "row",
                    gap: "20px",
                    // padding: "8px 14px"
                },
            }}
        >
            <div className="operation-container" style={{ maxWidth: selectedLog?.level ? "none" : "411.57px" }}>
                <div>
                    <DialogTitle id="alert-dialog-title">
                        <Tooltip placement="top" title={data.autom_name}>
                            <div id="about-title" className="add-group-header">
                                <div className="operation-tag-title-container">
                                    <div className={`autom-name-title-status operation-status-dot-${data.operation_status ? data.operation_status.toLowerCase()
                                        : data.scheduled_at ? "schedule" : ""}`}></div>
                                    <h4 className="autom-name-title">{data.autom_name}</h4>
                                </div>
                            </div>
                        </Tooltip>
                    </DialogTitle>
                    <DialogContent>
                        {/* <div>
                            <h5 className='logs-info-text'>{t(label + `LAST-STATUS`)}</h5>
                            <p className="bold-logs-info">{data.operation_status ? t(label + `${data.operation_status}`) : "-"}</p>
                        </div> */}
                        {/* {!isNewLogs ? <div>
                            <h5 className='logs-info-text'>{t(label + `STARTED-AT`)}</h5>
                            <p className="bold-logs-info">{data.created_on ? convertToDateFormat(data.created_on, personalization.date_format) : "-"}</p>
                        </div> : ""}
                        {!data.scheduled_at && !isNewLogs ? <div>
                            <h5 className='logs-info-text'>{t(label + `FINISHED-AT`)}</h5>
                            <p className="bold-logs-info">{data.finished_at ? convertToDateFormat(data.finished_at, personalization.date_format) : "-"}</p>
                        </div> : ""} */}
                        <div>
                            <h5 className='logs-info-text'>{t(label + `TRIGGER-TYPE`)}</h5>
                            <p className="bold-logs-info">{data.trigger_type ? data.trigger_type : "Manual Trigger"}</p>
                        </div>
                        {/* <div>
                            <h5 className='logs-info-text'>{t(label + `USAGE`)}</h5>
                            <p className="bold-logs-info">{operationCount}</p>
                        </div> */}
                        <div>
                            <h5 className='logs-info-text'>{t(label + `RUN-BY`)}</h5>
                            <p className="bold-logs-info">{data.run_by ? data.run_by : "-"}</p>
                        </div>
                    </DialogContent>
                </div>
                <div className="logs-seperator"></div>
                <div className="recent-logs-container">
                    <div className="recent-logs-header-container">
                        <div>
                            <h4 className="recent-logs-title">{t(label + `LOGS-SUMMARY`)}</h4>
                            {/* <small
                                className="conf-field-desc"><em>{t("CONTENT.AUTOMS-LIST.AUTOM-NAME-HELPER", { type: 'string' })}</em></small> */}
                            <small
                                className="conf-field-desc"><em>{t(label + `LOGS-SUMMARY-DESCRIPTION`)}</em></small>
                        </div>
                        <div className="logs-button-container">
                            <Close className="autom-group-close-button logs-close-icon" onClick={handleClose} style={{ fontSize: "1rem" }} />
                            <Button onClick={() => handleShowAllOperationLogs(data)} className="view-all-logs-button">{t(label + `VIEW-ALL-LOGS`)} {!isNewLogs ? `(${logsCount})` : ""}</Button>
                        </div>
                    </div>
                    <DialogContent className="log-detail-container">
                        {loading ? <div className='db-create-loading-page'><CircularProgress /></div>
                            : isNewLogs
                                ? <LogSummary
                                    data={data} handleOpenInfoArea={handleOpenInfoArea} setOpenEhLogs={setOpenEhLogs} label={label} />
                                : logs.length
                                    ? logs.map((log, index) => {
                                        if (index > 4) {
                                            return
                                        }
                                        const names = log.defination?.split('_')
                                        return isMidLogs ? <MidLogsDetail log={log} index={index} names={names}
                                            img={log.image?.includes('data:') ? log.image :
                                                `${base_origin}/libraries/${!log.image || log.is_system ? "system" : "custom"}/${log.image ? log.image : defaultLibraryImg}`
                                            }
                                            data={data}
                                            logType={log.tag === "autom_started" ? "Autom started" :
                                                log.tag === "autom_ended" ? "Autom ended" : ""}
                                            fetchData={fetchData}
                                            highlightText={highlightText}
                                        />

                                            : <OldLogsDetail log={log} index={index} names={names}
                                                img={log.image?.includes('data:') ? log.image :
                                                    `${base_origin}/libraries/${!log.image || log.is_system ? "system" : "custom"}/${log.image ? log.image : defaultLibraryImg}`
                                                }
                                                logType={log.text === "Flow started working" ? "Autom started" : log.text === "DebugFlow started working" ? "Debug Autom started" :
                                                    log.text === "Flow completed successfully" ? "Autom ended" : ""}
                                                fetchData={fetchData} />
                                    }) :
                                    <div className='empty-page-info-container'>
                                        <img src={emptyPageIcon} />
                                        <p className='info-text'>{t(label + 'EMPTY-LOGS')}</p>
                                    </div>
                        }
                    </DialogContent>
                </div>
            </div >
            {
                selectedLog.level && isNewLogs
                    //setSelectedLog, findLogIcon, setFullScreenValue, setOpenEhLogs, setType, showPreviewData, handleCopyInputAndOutput
                    ? <LogInfoDetails selectedLog={selectedLog} setSelectedLog={setSelectedLog} findLogIcon={findLogIcon} setFullScreenValue={setFullScreenValue}
                        setOpenEhLogs={setOpenEhLogs} setType={setType} label={label} type={type} /> : ""
            }
            {
                fullScreenValue.type ? <FullScreen title={fullScreenValue.type === "object" ? t(label + `PREVIEW`) : fullScreenValue.type}
                    handleClose={() => setFullScreenValue({ type: "", value: "" })} type={fullScreenValue.type ? fullScreenValue.type : "object"}
                    item={fullScreenValue} label={label}>
                    {type === "input"
                        ? <div className={`preview-data-content full-height`}>
                            {/* <ObjectInspector data={fullScreenValue.value ? fullScreenValue.value : {}} theme={customTheme} /> */}
                            {showPreviewData(fullScreenValue.value, fullScreenValue.type ? fullScreenValue.type : "object", fullScreenValue.cantParse, "fullScreen")}
                        </div>
                        : <div className={`preview-data-content full-height ${fullScreenValue.type === "data table" ? "preview-data-content-data-table" : ""}`}>
                            {/* {fullScreenValue.value} */}
                            {showPreviewData(fullScreenValue.value, fullScreenValue.type, fullScreenValue.cantParse, "fullScreen")}
                        </div>}
                </FullScreen> : ""
            }
            {openEhLogs ? <AllOperationLogs data={data} setOpenActivityLog={() => setOpenEhLogs(false)} setSelectedOperation={setSelectedOperation} ehLog={true} ehGroupId={openEhLogs} /> : ""}
        </Dialog >
    )
}
